<!--
  navItem "Konten/Salden" — the four balance values (real + simulated per account), the date of
  the last balance calculation, and the underfunding notice. Layout exclusively via PrimeFlex,
  colors exclusively via theme tokens.
-->
<div class="cp-provision-agent-balance">

    @if (!initialized) {

        <p-skeleton height="9rem" styleClass="mb-3"></p-skeleton>
        <p-skeleton height="12rem"></p-skeleton>

    } @else if (!provisionAgentId) {

        <p-message severity="info" text="Kein Abrechnungskonto ausgewählt." styleClass="w-full"></p-message>

    } @else if (!balanceDto) {

        <p-message severity="info"
                   text="Für dieses Abrechnungskonto wurden noch keine Salden berechnet."
                   styleClass="w-full"></p-message>

    } @else {

        <!-- Underfunding notice: THE PAYOUT BRAKE (U-03).

             `reserveUnderfunded` is set from `cpReserveUnderfunded()` — the module's ONE frontend
             statement of the rule, mirroring ProvisionPayoutService.reserveUnderfunded(). It is not
             re-derived in this template, and the second reserve notice below is deliberately worded
             as a FORECAST ("Drohende Unterdeckung") so that only one of the two ever reads as the
             thing that stops a payout. -->
        @if (reserveUnderfunded) {
            <p-message severity="error" styleClass="w-full mb-3">
                <span>
                    <i class="fa-regular fa-triangle-exclamation mr-2"></i>
                    <strong>Unterdeckung des Rücklagenkontos.</strong>
                    Der Rücklagensaldo ist negativ
                    ({{ balanceDto.reserveBalance | currency:'EUR':'symbol':'1.2-2' }}).
                    Auszahlungen an diesen Berater werden dadurch gebremst.
                </span>
            </p-message>
        } @else if (reserveSimulatedUnderfunded) {
            <p-message severity="warn" styleClass="w-full mb-3">
                <span>
                    <i class="fa-regular fa-circle-exclamation mr-2"></i>
                    <strong>Drohende Unterdeckung.</strong>
                    Der simulierte Rücklagensaldo ist negativ
                    ({{ balanceDto.reserveSimulatedBalance | currency:'EUR':'symbol':'1.2-2' }}) —
                    die bereits berechneten Buchungen führen das Rücklagenkonto ins Minus.
                </span>
            </p-message>
        }

        <!-- The four balance tiles -->
        <div class="grid mb-3">

            <div class="col-12 md:col-6 xl:col-3">
                <div class="cp-agent-balance-tile surface-card border-round p-3 h-full">
                    <div class="text-color-secondary text-sm mb-2">Provisionskonto</div>
                    <div class="text-2xl font-semibold">
                        {{ balanceDto.provisionBalance | currency:'EUR':'symbol':'1.2-2' }}
                    </div>
                    <div class="text-color-secondary text-xs mt-2">nur aktive Buchungen</div>
                </div>
            </div>

            <div class="col-12 md:col-6 xl:col-3">
                <div class="cp-agent-balance-tile surface-card border-round p-3 h-full">
                    <div class="text-color-secondary text-sm mb-2">Provisionskonto (simuliert)</div>
                    <div class="text-2xl font-semibold">
                        {{ balanceDto.provisionSimulatedBalance | currency:'EUR':'symbol':'1.2-2' }}
                    </div>
                    <div class="text-color-secondary text-xs mt-2">inklusive berechneter Buchungen</div>
                </div>
            </div>

            <div class="col-12 md:col-6 xl:col-3">
                <div class="cp-agent-balance-tile surface-card border-round p-3 h-full">
                    <div class="text-color-secondary text-sm mb-2">Rücklagenkonto</div>
                    <div class="text-2xl font-semibold"
                         [class.text-red-500]="reserveUnderfunded">
                        {{ balanceDto.reserveBalance | currency:'EUR':'symbol':'1.2-2' }}
                    </div>
                    <div class="text-color-secondary text-xs mt-2">nur aktive Buchungen</div>
                </div>
            </div>

            <div class="col-12 md:col-6 xl:col-3">
                <div class="cp-agent-balance-tile surface-card border-round p-3 h-full">
                    <div class="text-color-secondary text-sm mb-2">Rücklagenkonto (simuliert)</div>
                    <div class="text-2xl font-semibold"
                         [class.text-orange-500]="reserveSimulatedUnderfunded">
                        {{ balanceDto.reserveSimulatedBalance | currency:'EUR':'symbol':'1.2-2' }}
                    </div>
                    <div class="text-color-secondary text-xs mt-2">inklusive berechneter Buchungen</div>
                </div>
            </div>

        </div>

        <!-- Timestamp of the balance calculation -->
        <div class="flex align-items-center gap-2 mb-3">
            <i class="fa-regular fa-clock text-color-secondary"></i>
            <span class="text-color-secondary text-sm">
                Zuletzt berechnet:
                @if (balanceDto.lastCalculatedDate) {
                    {{ balanceDto.lastCalculatedDate | date:'dd.MM.yyyy HH:mm' }}
                } @else {
                    noch nie
                }
            </span>
        </div>

        <!-- Full balance row as a read-only data widget -->
        @if (balanceWidget) {
            <mvs-widget [widgetData]="balanceWidget"></mvs-widget>
        }

    }

</div>
